import React, { PropsWithChildren } from 'react';

import { LinkMore } from '../web/button/linkMore';

interface PersonaProps extends PropsWithChildren {
  className?: string;
  title: string;
  description: string;
  imgSrc: string;
  imgRight?: boolean;
  learnMoreUrl?: string;
  onClick?: () => void;
}

const Persona = (props: PersonaProps) => {
  const containerClass = props.imgRight
    ? `${classNames.container} tw-flex-col-reverse`
    : `${classNames.container} tw-flex-col`;

  return (
    <div
      className={
        props.className
          ? `${containerClass} ${props.className}`
          : containerClass
      }
    >
      {!props.imgRight && (
        <img className={classNames.image} src={props.imgSrc} />
      )}
      <div className={classNames.textContainer}>
        <h1 className={classNames.title}>{props.title}</h1>
        <h2 className={classNames.description}>{props.description}</h2>
        {props.learnMoreUrl && (
          <LinkMore
            className={classNames.learnMore}
            text="Learn"
            link={props.learnMoreUrl}
            onClick={props.onClick}
          />
        )}
      </div>
      {props.imgRight && (
        <img className={classNames.image} src={props.imgSrc} />
      )}
    </div>
  );
};

const classNames = {
  container: [
    'tw-flex',
    'tw-items-center',
    'md:tw-flex-row',
    'tw-gap-[16px]',
    'md:tw-gap-[20px]',
    'xl:tw-gap-[105px]',
  ].join(' '),
  image: [
    'tw-object-contain',
    'tw-max-h-[160px]',
    'md:tw-max-h-[216px]',
    'xl:tw-max-h-[320px]',
  ].join(' '),
  textContainer: [
    'tw-flex',
    'tw-flex-col',
    'tw-items-center',
    'md:tw-items-start',
    'tw-text-center',
    'md:tw-text-start',
  ].join(' '),
  title: ['tw-h2-emphasis', 'tw-mb-[8px]', 'md:tw-mb-[16px]'].join(' '),
  description: ['tw-h3'].join(' '),
  learnMore: ['tw-mt-[16px]', 'md:tw-mt-[24px]', 'xl:tw-mt-[32px]'].join(' '),
};
export { Persona };
